import useAlerts from './useAlerts';
import useGlobalUrl from '@/composables/useGlobalUrl';
import useSilentAccessToken from './useSilentAccessToken';

const { addAlert } = useAlerts();
const { quoteProductImportUrl } = useGlobalUrl();

export default function useQuoteProductImport() {
  async function importQuoteProducts(file, priceListId) {
    const { getAccessToken } = useSilentAccessToken();
    const token = await getAccessToken();

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('pricelistid', priceListId);

      const result = await fetch(`${quoteProductImportUrl}/import?pricelistid=${encodeURIComponent(priceListId)}`, {
        method: 'POST',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: formData,
      });
      const response = await result.json().catch(() => ({}));

      if (!result.ok) {
        throw new Error(response.error || 'Error importing quote products');
      }

      addAlert(`Imported ${response.added} new and ${response.updated} updated quote products`, 'low', 4);
      return response;
    } catch (error) {
      console.error(error);
      addAlert(error.message || 'Error importing quote products', 'high', 4);
      return null;
    }
  }

  return { importQuoteProducts };
}
